/* eslint dom-in-jsx/no-jquery-in-jsx: 0 */
/* eslint dom-in-jsx/no-document-calls: 0 */

import React, { Component } from 'react';
import * as uuid from 'uuid';
import HashFormItem from './HashFormItem.jsx';
import JsonPreview from '../JsonPreview.jsx';
import { parseValueItem } from './hashUtils.jsx';
import HashActionDropdown from './HashActionDropdown.jsx';
import EventEmitter from '../../util/eventEmitter.js';
import _ from 'underscore';

export default class HashForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: parseValueItem(props.value, props.template),
      openModal: false,
      hasError: false,
      formEnabled: this.getInitialEnabledState(props),
      formToSubmit: false,
      items: this.generateItems(),
    };

    this.initialReference = uuid.v4();
    this.toggleModal = this.toggleModal.bind(this);
    this.enableForm = () => this.setState({ formEnabled: true });
    this.disableForm = () => this.setState({ formEnabled: false });
    this.formToSubmit = () => this.setState({ formToSubmit: true });
    this.handleCopyFromParent = () =>
      this.setState((state, currProps) => ({
        value: parseValueItem(currProps.parentValue, currProps.template),
        items: this.generateItems(),
      }));

    this.listen();
  }

  getInitialEnabledState(props) {
    if (props.location.href.indexOf('?edit=1') > -1) {
      return true;
    }
    if (!props.errors || Object.keys(props.errors).length === 0) {
      return false;
    }
    return true;
  }

  componentDidUpdate(_prevProps, prevState) {
    if (prevState.hasError === this.state.hasError) {
      return;
    }
    if (this.state.hasError) {
      EventEmitter.emit('disableHashFormSubmit');
    } else {
      EventEmitter.emit('enableHashFormSubmit');
    }
  }

  componentWillUnmount() {
    EventEmitter.off('openHashFormPreview', this.toggleModal);
    EventEmitter.off('enableHashForm', this.enableForm);
    EventEmitter.off('disableHashForm', this.disableForm);
  }

  listen() {
    EventEmitter.on('openHashFormPreview', this.toggleModal);
    EventEmitter.on('enableHashForm', this.enableForm);
    EventEmitter.on('disableHashForm', this.disableForm);
    EventEmitter.on('hashFormSubmit', (e) => {
      this.formToSubmit;
      var is_valid_form = e.currentTarget.form.checkValidity();
      if (!is_valid_form) {
        e.preventDefault();
        setTimeout(() => e.currentTarget.form.reportValidity(), 800);
      }
    });
  }

  finalValue(val) {
    return typeof val === 'object' && !this.isValueArray(val)
      ? this.buildValueItem(val)
      : this.removeInitialReference(val);
  }

  removeInitialReference(value) {
    if (!Array.isArray(value)) {
      return value === `$${this.initialReference}` ? '' : value;
    }

    return value.map((v) => {
      if (v === `$${this.initialReference}`) {
        return '';
      }

      return v;
    });
  }

  buildValueItem(item) {
    let obj = [],
      val;

    if (_.isEmpty(_.compact(item))) {
      return obj;
    }

    if (Array.isArray(_.first(item)?.key)) {
      _.first(item).key.map((key, index) => {
        val = _.first(item).value[index];
        obj.push({
          id: _.first(item).id,
          enabled: _.first(item).enabled,
          key: key.value,
          value: _.first(item).enabled ? this.finalValue(val) : [],
        });
      });
    } else {
      item.map((subitem) => {
        if (typeof subitem === 'undefined') {
          return;
        }
        val = subitem.value;
        obj.push({
          id: subitem.id,
          enabled: subitem.enabled,
          key: subitem.key.value,
          value: subitem.enabled ? this.finalValue(val) : [],
        });
      });
    }

    return obj;
  }

  isValueArray(val) {
    return (
      Array.isArray(val) && !_.isEmpty(val) && typeof _.first(val) !== 'object'
    );
  }

  toggleModal() {
    this.setState((state) => {
      return { openModal: !state.openModal };
    });
  }

  buildValue(value) {
    return this.buildValueItem(value);
  }

  handleChange(item, keyIndex, index) {
    let values = this.state.value;

    values[index] = item;
    // Reset hasError value to false when value is updated to account for possible fix. If the error
    // persist, the HashFormItem child will call onError property and set hasError to true.
    this.setState({ value: values, hasError: false, formToSubmit: false });
  }

  toggleSubmitButton() {
    if (!this.state.hasError) {
      this.setState({ hasError: true });
    }
  }

  valueFor(values, id) {
    return values.find((i) => i.id === id);
  }

  generateItems() {
    return this.props.template.map((template) => ({
      id: uuid.v4(),
      template: template,
    }));
  }

  render() {
    let globalError = this.props.errors && this.props.errors['0:'];
    const { resourceType } = this.props;

    return (
      <div className='HashFormComponent'>
        <input
          readOnly
          name={this.props.name}
          type='hidden'
          value={JSON.stringify(this.buildValue(this.state.value))}
        />
        <If condition={typeof globalError !== 'undefined'}>
          <div className='error'>{globalError}</div>
        </If>
        {this.state.items.map((item, index) => (
          <HashFormItem
            key={item.id}
            animate={false}
            errors={this.props.errors || {}}
            formEnabled={this.state.formEnabled}
            formToSubmit={this.state.formToSubmit}
            heightChanged={() => this.setState({ formToSubmit: false })}
            index={index}
            initialReference={this.initialReference}
            level={0}
            parentDisabled={false}
            properties={this.props.properties}
            propertyLabels={this.props.propertyLabels}
            template={item.template}
            value={this.valueFor(this.state.value, item.template.id)}
            zIndex={200 - index}
            onChange={this.handleChange.bind(this)}
            onError={() => this.toggleSubmitButton()}
          />
        ))}
        <JsonPreview
          hosts={this.props.hosts}
          link={this.props.hashValueLink}
          name={this.props.templateName}
          open={this.state.openModal}
          renderedEntity={'hash'}
          title={this.props.title}
          onClose={() => this.setState({ openModal: false })}
        />
        {resourceType === 'node_group' ? null : (
          <HashActionDropdown
            handleCopy={this.handleCopyFromParent}
            hasParentValue={
              this.props.parentValue && this.props.parentValue.length > 0
            }
            parentName={this.props.parentName}
            path={this.props.path}
            propertyName={this.props.propertyName}
            resourceName={this.props.resourceName}
            resourceType={this.props.resourceType}
            templateName={this.props.templateName}
          />
        )}
      </div>
    );
  }
}
